// extracted by mini-css-extract-plugin
export default {"popupText":"popupText__officeNumbers__O0nVq","baseText":"baseText__officeNumbers__Fc3yt"};